export const DEMO_PRACTICE_FACTOR_MIN = 0.7;
export const DEMO_PRACTICE_FACTOR_MAX = 0.9;
/** Demo practice pain/function: keep pre, stretch the pre→post change by 15%. */
export const DEMO_PRACTICE_OUTCOME_CHANGE_SCALE = 1.15;

function hashStringToUnit(value) {
  const text = String(value ?? '');
  let hash = 2166136261;
  for (let i = 0; i < text.length; i += 1) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) / 4294967296;
}

/** Stable demo factor in [0.7, 0.9], keyed by patient so charts do not flicker. */
export function demoPracticeOverlayFactor(patientId) {
  const unit = hashStringToUnit(patientId || 'demo-practice');
  return DEMO_PRACTICE_FACTOR_MIN + unit * (DEMO_PRACTICE_FACTOR_MAX - DEMO_PRACTICE_FACTOR_MIN);
}

export function scaleResearchRateForPractice(researchValue, factor) {
  if (researchValue == null || researchValue === '') return null;
  const n = Number(researchValue);
  const f = Number(factor);
  if (!Number.isFinite(n) || n < 0 || !Number.isFinite(f) || f <= 0) return null;
  return n * f;
}

/** Control bars keep research rates; surgery bars use live or scaled practice data. */
export function resolvePracticeAwareRiskPct({
  key,
  researchPct,
  livePracticePct,
  practiceStats,
  practiceOverlayFactor,
}) {
  if (key === 'control') return researchPct;
  if (practiceStats != null) return livePracticePct;
  if (practiceOverlayFactor != null) {
    return scaleResearchRateForPractice(researchPct, practiceOverlayFactor) ?? researchPct;
  }
  return researchPct;
}

/** Keep prior; scale (after − prior) and clamp to [min, max]. */
export function scaleOutcomeChangeForPractice(
  prior,
  after,
  scale = DEMO_PRACTICE_OUTCOME_CHANGE_SCALE,
  { min = 0, max = Infinity } = {},
) {
  if (prior == null || prior === '' || after == null || after === '') return null;
  const p = Number(prior);
  const a = Number(after);
  const s = Number(scale);
  const lo = Number(min);
  const hi = Number(max);
  if (!Number.isFinite(p) || !Number.isFinite(a) || !Number.isFinite(s) || s <= 0) return null;
  const scaled = p + (a - p) * s;
  if (!Number.isFinite(scaled)) return null;
  const lower = Number.isFinite(lo) ? lo : 0;
  const upper = Number.isFinite(hi) ? hi : Infinity;
  return Math.min(upper, Math.max(lower, scaled));
}
